module.exports = __webpack_public_path__ + "img/pic5.b1c631d0.jpg";